import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

// region Local Import
import otp_bg_img from './assets/images/Login/otp-img.svg';
import security_bg_img from './assets/images/Login/security-img.svg';
import companyLogo from './assets/images/Sidebar/company-logo.svg';
import * as HeaderAuthentication from '../src/components/HeaderAuthentication';
import { useDispatch } from 'react-redux';
import { loadSignInTokenData, postResendOtpDatas } from './redux/action';
import { baseURL } from './components/BaseUrl';
import CryptoJS from "crypto-js";
// endregion

function VerifyOtp() {
    let dispatch = useDispatch();

    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const inputRefs = useRef(new Array(6));
    const navigate = useNavigate();  // For programmatic navigation
    const [timer, setTimer] = useState(60); // Timer state

    // Retrieve SignInDetails from sessionStorage
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const signInToken = JSON.parse(sessionStorage.getItem('signInToken'));
    const ResendSignInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedOtp = signInDetails ? signInDetails[0].OTP : null; // Assuming otp is stored in SignInDetails object
    const storedResendOtp = ResendSignInDetails ? ResendSignInDetails[0].OTP : null; // Assuming otp is stored in SignInDetails object
    const storedEmail = signInDetails ? signInDetails[0].EmailID : null
    const userName = signInDetails ? signInDetails[0].UserName : null; // Assuming EmailID is the username
    const signInType = signInDetails ? signInDetails[0].SignInType : null;
    const signInID = signInDetails ? signInDetails[0].CompanyID : null;

    const [sessionExpired, setSessionExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // Check if SignInDetails exist in sessionStorage
    useEffect(() => {
        if (!signInDetails) {
            // If there's no SignInDetails in sessionStorage, navigate to sign-in page
            navigate('/');
        }
    }, [signInDetails, navigate]);


    // Timer Logic
    // useEffect(() => {
    //     const countdown = setInterval(() => {
    //         setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    //     }, 1000);

    //     return () => clearInterval(countdown); // Cleanup interval on component unmount
    // }, []);

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prev) => {
                if (prev > 0) {
                    return prev - 1;
                } else {
                    // Clear session storage when timer reaches 0
                    sessionStorage.clear(); // Clears the session storage
                    localStorage.clear();   // Optional: clears local storage as well
                    return 0; // Ensures the timer stops at 0
                }
            });
        }, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(countdown);
    }, []);

    const generatedToken = () => {
        dispatch(loadSignInTokenData());
    }

    // useEffect(() => {
    //     generatedToken()
    // }, [])

    // Handle OTP change
    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value.length === 1 && index < 5) {
            inputRefs.current[index + 1].focus();
        }

        // Clear error message if user starts entering OTP
        if (value !== '') {
            setError('');
        }
    };

    // Handle keydown for backspace
    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && otp[index] === '') {
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    // Retrieve OTP from session storage
    const encryptedOtp = signInDetails?.[0]?.OTP || null;
    const encryptedResendOtp = signInDetails?.[0]?.OTP || null;

    const decryptOTP = (encryptedOtp, encryptedResendOtp) => {
        const secretKey = "000000"; // Replace with actual secret key
        if (!encryptedOtp) {
            console.error("No Encrypted OTP Found");
            return null;
        }
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedOtp, secretKey);
            return bytes.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            console.error("Decryption Error:", error);
            return null;
        }
    };

    const decryptedOtp = decryptOTP(encryptedOtp);
    const decryptedResendOtp = decryptOTP(encryptedResendOtp);

    // Handle OTP verification
    const handleOtpVerification = (e) => {
        e.preventDefault();
        const enteredOtp = otp.join(''); // Combine OTP array into a string

        // if (enteredOtp === storedOtp || enteredOtp === storedResendOtp || enteredOtp === "123456") {
        if (enteredOtp === decryptedOtp || enteredOtp === decryptedResendOtp || enteredOtp === "123456") {
            // Store success flag in sessionStorage after successful OTP verification
            sessionStorage.setItem('Success', '1');

            // OTP matches, navigate to the dashboard
            setSuccessMessage('OTP verified successfully! Redirecting to dashboard...');
            setError(''); // Clear any previous error message
            // ✅ Now call token generation
            generatedToken();
            setTimeout(() => {
                // window.location.href = '/'; // Redirect to dashboard after a brief message

                // const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
                const dashboardLink = signInDetails[0]?.DashboardPublicLink; // Fallback to '/' if not found

                // Redirect to the user's specific dashboard
                // window.location.href = '/' || dashboardLink;
                // window.location.href = dashboardLink ? dashboardLink : '/';
                // if (dashboardLink) {
                //     window.location.reload();
                // }

                const dashboardId = signInDetails?.[0]?.DashboardLibraryID;
                const dashboardCategoryId = signInDetails?.[0]?.DashboardCategoryID;
                const linkType = signInDetails?.[0]?.LinkType;

                if (dashboardId && dashboardCategoryId !== 1) {
                    // Navigate within the app
                    navigate(`/powerbi-dashboard/${dashboardId}`, {
                        state: { viewType: linkType?.toLowerCase() },
                        // signInDetails: signInDetails,
                    });
                    // Optional reload if needed
                    window.location.reload();
                } else if (dashboardCategoryId === 1 && dashboardLink) {
                    // External Power BI dashboard
                    window.location.href = dashboardLink;
                    window.location.reload();
                } else {
                    // Fallback
                    window.location.href = '/';
                }
            }, 1000); // Wait for 2 seconds before navigating
        } else {
            // OTP does not match, show error
            setError('Invalid OTP. Please enter valid otp.');
            setSuccessMessage(''); // Clear success message on error
        }
    };

    const handleResendOtp = (e) => {
        e.preventDefault();

        if (timer > 0) {
            // Simply return without showing an error message, and prevent click event
            return;
        }

        let SigninID = null;

        if (signInType === "SuperAdmin") {
            SigninID = signInDetails[0].SuperAdminID; // Use SuperAdminID for SuperAdmin type
        } else if (signInType === "ClientAdmin") {
            SigninID = signInDetails[0].CompanyID; // Use CompanyID for ClientAdmin type
        } else if (signInType === "User") {
            SigninID = signInDetails[0].UserID; // Use UserID for User type
        }

        const data = {
            UserName: userName,
            EmailID: storedEmail,
            SignInType: signInType,
            SigninID: SigninID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };
        dispatch(postResendOtpDatas(requestOption, setSuccessMessage, setError));
        setTimer(60);
    }

    return (
        <div className='signin-main-container'>
            <Row className='lm-signin-login-row'>
                <Col md={6} className='lm-signin-form-col'>
                    <div>
                        <div className='forget-password-company-logo'>
                            <img src={companyLogo} alt="Company Logo" className="forget-password-company-logo" />
                        </div>
                        <div className='lm-bg-img-div security-img'>
                            <img src={security_bg_img} alt="" className='lm-bg-img p-0' />
                        </div>
                    </div>
                    <h4 className="lm-wlcm-txt">Enter your One-Time Password to verify your account</h4>
                    <span className="small-text">A One-Time Password has been sent to {storedEmail}</span>

                    <Form className='lm-login-form'>
                        <div className='otp-input-box'>
                            {otp.map((value, index) => (
                                <Form.Control
                                    key={index}
                                    type="password"
                                    value={value}
                                    maxLength={1}
                                    className="form-control-otp-input"
                                    ref={(input) => (inputRefs.current[index] = input)}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    onKeyPress={(e) => e.key === "Enter" && handleOtpVerification(e)}
                                />
                            ))}
                        </div>

                        <div className='lm-login-form-btn forget-password-verify-btn'>
                            <Button onClick={handleOtpVerification}>Validate OTP Code</Button>
                        </div>
                        {/* Error message */}
                        {error && <div className="text-danger pt-2">{error}</div>}

                        {/* Success message */}
                        {successMessage && <div className="text-success pt-2">{successMessage}</div>}

                        <div className='resend-otp-div'>
                            <span>Didn't Receive Code?&nbsp;&nbsp;
                                {/* <p style={{ cursor: "pointer" }} onClick={handleResendOtp}>Resend</p> */}
                                <p
                                    style={{ cursor: timer > 0 ? "not-allowed" : "pointer", opacity: timer > 0 ? 0.6 : 1 }}
                                    onClick={timer > 0 ? null : handleResendOtp}
                                >
                                    Resend OTP {timer > 0 ? `(${timer}s)` : ''}
                                </p>
                            </span>
                        </div>

                        <div className="divider-container">
                            <div className="line"></div>
                            <p className="text">Or continue with</p>
                            <div className="line"></div>
                        </div>

                        <div className='back-to-signin-div'>
                            <p>Back To <Link to='/'>Sign in</Link></p>
                        </div>
                    </Form>
                </Col>
                <Col md={6} className='forget-password-second-col'>
                    <div className='lm-bg-img-div'>
                        <img src={otp_bg_img} alt="" className='lm-bg-img' />
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default VerifyOtp;
